module.exports = __webpack_public_path__ + "img/loginBg.eb61c9a8.png";